import React from 'react';
import DocumentMeta from 'react-document-meta';

function ComingSoon() {

    const meta = {
        title: 'MetaFans Has Moved | MF Legends',
        description: 'MetaFans is evolving into MetaFans Legends. Visit the new platform to explore the MetaFans 3.0 ecosystem and NFT mint.',
    };

    const openNewSite = () => {
        window.open("https://mflegends.com/", "_blank");
    };

    return (
        <>
            <DocumentMeta {...meta} />

            <div
                className="min-h-screen flex items-center justify-center px-6"
                style={{
                    background: `linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.85)), url('https://images.unsplash.com/photo-1621303837374-6f8f47b43239?auto=format&fit=crop&w=1920&q=80')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundAttachment: 'fixed',
                    fontFamily: "'Arial', sans-serif",
                }}
            >

                <div className="max-w-3xl text-center bg-white/10 backdrop-blur-xl rounded-2xl p-10 md:p-14 border border-white/20 shadow-2xl">

                    {/* Badge */}
                    <div className="inline-block mb-6 px-4 py-1 rounded-full bg-indigo-500/20 border border-indigo-400/40 text-indigo-300 text-xs font-semibold tracking-widest uppercase">
                        Platform Update
                    </div>

                    {/* Headline */}
                    <h1 className="text-3xl md:text-5xl font-extrabold text-white leading-tight mb-6">
                        MetaFans Has Evolved
                        <br />
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400">
                            Welcome to MF Legends
                        </span>
                    </h1>

                    {/* Description */}
                    <p className="text-gray-300 text-lg leading-relaxed mb-8">
                        The MetaFans platform has migrated to our new home as part of the
                        <strong className="text-white"> MetaFans 3.0 ecosystem</strong>.
                        The new platform introduces the <strong className="text-white">MF Legends NFT Collection</strong>,
                        a community point system, tier-based rewards, and exclusive sports competitions.
                    </p>

                    <p className="text-gray-400 text-sm mb-10">
                        To explore the new experience and access the latest updates, please visit the new platform.
                    </p>

                    {/* CTA Button */}
                    <button
                        onClick={openNewSite}
                        className="px-8 py-4 rounded-full text-lg font-bold text-white bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 hover:from-indigo-500 hover:via-purple-500 hover:to-pink-500 transition-all shadow-lg hover:shadow-purple-500/30 transform hover:scale-105"
                    >
                        Visit the New MF Legends Platform →
                    </button>

                    {/* small link fallback */}
                    <div className="mt-6 text-gray-500 text-sm">
                        or go directly to
                        <br />
                        <a
                            href="https://mflegends.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-indigo-400 hover:text-indigo-300 underline"
                        >
                            https://mflegends.com
                        </a>
                    </div>

                </div>
            </div>
        </>
    );
}

export default ComingSoon;